import { adminSupabase, supabase } from '@/lib/supabase'
import type { QueueState } from './migrationQueue'
import { isWorkflowReadOnlyHost } from '@/lib/workflowOwner'
const mock=import.meta.env.VITE_RELEASE_OPS_MOCK==='true'
const readOnly=()=>mock||typeof location==='undefined'||isWorkflowReadOnlyHost(location.hostname)
async function call(action:string,extra:Record<string,unknown>={}){
 const {data:{session}}=await supabase.auth.getSession();if(!session?.access_token)throw new Error('נדרשת התחברות מחדש')
 const {data,error}=await adminSupabase.functions.invoke('release-ops',{body:{action,...extra},headers:{Authorization:`Bearer ${session.access_token}`}})
 if(error||!data?.ok)throw new Error('admin_queue_unavailable');return data
}
export const adminMigrationQueueApi={
 get readOnly(){return readOnly()},
 async state():Promise<QueueState>{
  if(mock)return {paused:true,guard_on:true,window_open:false,break_glass_active_until:null,items:[{id:'admin-preview',version:'20271022053834',name:'admin_queue_bootstrap',repo:'the-Otomator/otomator-admin',status:'pending',held:false,emergency:true,pr_url:null,last_error:null,sql:null}]}
  const data=(await call('admin_queue_state')).state
  if(!data||!Array.isArray(data.items))throw new Error('admin_queue_response_invalid');return data
 },
 async action(id:string|null,action:'approve'|'hold'|'release'|'retry'|'cancel'|'pause'|'resume',reason:string){
  if(readOnly())throw new Error('תצוגה מקדימה בלבד')
  await call('admin_queue_action',{item_id:id,queue_action:action,reason})
 },
}
